export enum AppRoute {
  HOME = '/',
  QRCODE_FEEDBACK_PAGE = '/qrcode/:slug',
  MEDFLEX_FEEDBACK_PAGE = '/mf/:slug',
  FEEDBACK = '/:slug',
  FEEDBACK_SUCCESS = '/:slug/success',
  FEEDBACK_FAIL = '/:slug/fail',
  FEEDBACK_SUBMIT = '/:slug/submit',
}
